import React, { useCallback, useMemo } from 'react'
import { Button, Dropdown, DropdownItem, Icon, Popover } from 'gu-ui-kit'
import { useDispatch, useSelector } from 'react-redux'
import styles from 'components/Footer/subcomponents/LanguageSelector/language-selector.module.scss'
import { useTranslation } from 'react-i18next'
import { SET_I18N } from 'modules/App/types'
import { LOCALES } from 'constants/app-config'

const LanguageSelector = () => {
  const { t } = useTranslation()

  const { bindTrigger, bindPopover, usePopupState } = Popover.usePopover()

  const popoverState = usePopupState({
    variant: 'popover',
    id: 'language-selector-popover',
  })

  const dispatch = useDispatch()
  const { i18n } = useSelector(({ app }) => app)

  const setLang = useCallback(
    (value) => {
      popoverState.close()
      dispatch({ type: SET_I18N, payload: { i18n: value } })
    },
    [dispatch, popoverState],
  )

  const options = useMemo(
    () =>
      LOCALES.map((lng) => ({
        value: lng,
        label: t(`common::languages.${lng}`),
      })) ?? [
        {
          value: 'ru',
          label: 'Русский',
        },
        {
          value: 'en',
          label: 'English',
        },
      ],
    [],
  )

  const currentOption = useMemo(
    () => options.find((opt) => opt.value === i18n),
    [i18n],
  )

  return (
    options.length > 1 && (
      <div className={styles['language-selector']}>
        <Button
          noWrap
          variant={'secondary'}
          grey
          link
          // color={'text-primary'}
          // bgColor={'basic-primary-white'}
          // bgColorHover={'basic-primary-white'}
          // bgColorActive={'basic-primary-white'}
          size={'s'}
          endIcon={<Icon name={'arrow1-down'} />}
          className={styles['language-selector__trigger-button']}
          {...bindTrigger(popoverState)}
        >
          <DropdownItem
            variant={'p8'}
            className={styles['language-selector__option']}
          >
            <Icon
              name={'flag-' + currentOption?.value}
              width={18}
              height={13}
            />
            {currentOption?.label}
          </DropdownItem>
        </Button>

        <Popover
          bodyClassName={styles['language-selector__popover-inner']}
          {...bindPopover(popoverState)}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
        >
          <Dropdown className={styles['language-selector__dropdown']}>
            {options.map((opt) => (
              <DropdownItem
                variant={'p8'}
                key={'lang-' + opt.value}
                onClick={() => setLang(opt.value)}
                className={styles['language-selector__option']}
              >
                <Icon name={'flag-' + opt.value} width={18} height={13} />
                {opt.label}
              </DropdownItem>
            ))}
          </Dropdown>
        </Popover>
      </div>
    )
  )
}

export default LanguageSelector
